import React, { useState } from "react";
import "./index.scss"; // 假设Header组件和Header.scss文件在同一目录下
import { useNavigate, Link } from "react-router-dom"; // 引入Link和useNavigate 3
import { useUser } from "@/assets//UserContext";
import { Menu, Button, Avatar, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
const items = [
  {
    label: "首页",
    key: "1",
  },
  {
    label: "AI教程",
    key: "2",
    children: [
      {
        label: "视频教程",
        key: "2-1",
      },
      {
        label: "文章教程",
        key: "2-2",
      },
      {
        label: "技术论文",
        key: "2-3",
      },
    ],
  },
  {
    label: "AI工具",
    key: "3",
  },
  {
    label: "软件引擎",
    key: "4",
  },
  {
    label: "AI交易所",
    key: "5",
    children: [
      {
        label: "算力交易",
        key: "5-1",
      },
      {
        label: "数据集交易",
        key: "5-2",
      },
      {
        label: "AI定制服务",
        key: "5-3",
      },
    ],
  },
  {
    label: "AI工作",
    key: "6",
  },
  {
    label: "产业生态",
    key: "7",
    // children: [
    //   // {
    //   //   label: '产业资讯',
    //   //   key: '7-1',
    //   // },
    //   //  {
    //   //   label: '产业活动',
    //   //   key: '7-2',
    //   // }, {
    //   //   label: '行业名录',
    //   //   key: '7-3',
    //   // }, {
    //   //   label: '研究报告',
    //   //   key: '7-4',
    //   // }
    // ]
  },
];
// 假设的图标组件
const Logo = () => (
  <div className="header-logo">
    <img src={require("./img/logo.png")} alt="Logo" className="logo" />
  </div>
);

// 菜单项组件

const MenuItem = () => {
  const [current, setCurrent] = useState("mail");
  const navigate = useNavigate(); // 直接在组件内使用useNavigate hook
  const onClickMenu = (e) => {
    if (e.key === "1") {
      navigate("/home"); // 编程式导航
    }
    if (e.key === "2-1") {
      navigate("/videotutorials"); // 编程式导航
    }
    if (e.key === "2-3") {
      navigate("/papertutorials"); // 编程式导航
    }
    if (e.key === "5-1") {
      navigate("/computationaltrading"); // 编程式导航
    }
    if (e.key === "2-2") {
      navigate("/tutorial"); // 编程式导航
    }
    if (e.key === "3") {
      navigate("/tool"); // 编程式导航
    }
    if (e.key === "5-2") {
      navigate("/dataset_list"); // 编程式导航
    }
    if (e.key === "5-3") {
      navigate("/service"); // 编程式导航
    }
    if (e.key === "7") {
      navigate("/industry_news"); // 编程式导航
    }

    setCurrent(e.key);
  };
  return (
    <Menu
      onClick={onClickMenu}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
    />
  );
};

// 登录/注册按钮组件
const LoginRegisterButtons = () => {
  return (
    <div className="header-login-register">
      <Link to="/login?mode=login">登录</Link>/
      <Link to="/login?mode=register">注册</Link>
      {/* <Link to='/login'><IdcardTwoTone /></Link> */}
    </div>
  );
};

// Header组件
const Header = () => {
  const { user, logoutUser } = useUser();
  const navigate = useNavigate();
  // const [current, setCurrent] = useState("mail");
  const [drawerVisible, setDrawerVisible] = useState(false);

  const onClickMenu = (e) => {
    if (e.key === "1") {
      navigate("/home"); // 编程式导航
    }
    if (e.key === "2-1") {
      navigate("/videotutorials"); // 编程式导航
    }
    if (e.key === "2-3") {
      navigate("/papertutorials"); // 编程式导航
    }
    if (e.key === "5-1") {
      navigate("/computationaltrading"); // 编程式导航
    }
    if (e.key === "2-2") {
      navigate("/tutorial"); // 编程式导航
    }
    if (e.key === "3") {
      navigate("/tool"); // 编程式导航
    }
    if (e.key === "5-2") {
      navigate("/dataset_list"); // 编程式导航
    }
    if (e.key === "5-3") {
      navigate("/service"); // 编程式导航
    }
    if (e.key === "7") {
      navigate("/industry_news"); // 编程式导航
    }

    // setCurrent(e.key);
  };
  const handleLogout = () => {
    // 清除 session storage
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");

    // 清除 context
    logoutUser(null);

    // 跳转到首页
    navigate("/");
  };
  return (
    <header className="header">
      <Logo />

      {/* PC端菜单 */}
      <div className="pc-menu">
        <MenuItem />
      </div>

      {/* 移动端菜单按钮 */}
      <div className="mobile-menu">
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={() => setDrawerVisible(true)}
          className="menu-button"
        />
      </div>

      {/* 移动端抽屉菜单 */}
      <Drawer
        title="渐风AI"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        className="mobile-drawer"
        width={250}
      >
        <Menu
          mode="vertical"
          items={items}
          onClick={(e) => {
            onClickMenu(e);
            setDrawerVisible(false);
          }}
        />

        <div className="drawer-footer">
          <div className="icon-container">
            <a href="https://ollama.com" target="_blank" rel="noreferrer">
              <img
                src={require("./img/ollma.png")}
                alt="Ollama"
                className="ollma"
              />
            </a>
            <a
              href="https://github.com/aijfeng"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                height="32"
                aria-hidden="true"
                viewBox="0 0 24 24"
                version="1.1"
                width="32"
                data-view-component="true"
                className="octicon octicon-mark-github"
              >
                <path d="M12.5.75C6.146.75 1 5.896 1 12.25c0 5.089 3.292 9.387 7.863 10.91.575.101.79-.244.79-.546 0-.273-.014-1.178-.014-2.142-2.889.532-3.636-.704-3.866-1.35-.13-.331-.69-1.352-1.18-1.625-.402-.216-.977-.748-.014-.762.906-.014 1.553.834 1.769 1.179 1.035 1.74 2.688 1.25 3.349.948.1-.747.402-1.25.733-1.538-2.559-.287-5.232-1.279-5.232-5.678 0-1.25.445-2.285 1.178-3.09-.115-.288-.517-1.467.115-3.048 0 0 .963-.302 3.163 1.179.92-.259 1.897-.388 2.875-.388.977 0 1.955.13 2.875.388 2.2-1.495 3.162-1.179 3.162-1.179.633 1.581.23 2.76.115 3.048.733.805 1.179 1.825 1.179 3.09 0 4.413-2.688 5.39-5.247 5.678.417.36.776 1.05.776 2.128 0 1.538-.014 2.774-.014 3.162 0 .302.216.662.79.547C20.709 21.637 24 17.324 24 12.25 24 5.896 18.854.75 12.5.75Z"></path>
              </svg>
            </a>
          </div>
          {user && user.phone ? (
            <div className="user-info">
              <Avatar size="small" src={`/file/${user.profilePictureUrl}`} />
              <span>{user.phone}</span>
              <Button type="link" onClick={handleLogout}>
                退出登录
              </Button>
            </div>
          ) : (
            <div className="login-buttons">
              <Button type="link" onClick={() => navigate("/login")}>
                登录
              </Button>
              <Button type="link" onClick={() => navigate("/login")}>
                注册
              </Button>
            </div>
          )}
        </div>
      </Drawer>
      {/* PC端的其他元素 */}
      <div className="pc-elements">
        <a href="https://ollama.com" target="_blank" rel="noreferrer">
          <img src={require("./img/ollma.png")} alt="Logo" className="ollma" />
        </a>
        <a
          href="https://github.com/aijfeng"
          target="_blank"
          rel="noreferrer"
          className="github"
        >
          <svg
            height="32"
            aria-hidden="true"
            viewBox="0 0 24 24"
            version="1.1"
            width="32"
            data-view-component="true"
            className="octicon octicon-mark-github"
          >
            <path d="M12.5.75C6.146.75 1 5.896 1 12.25c0 5.089 3.292 9.387 7.863 10.91.575.101.79-.244.79-.546 0-.273-.014-1.178-.014-2.142-2.889.532-3.636-.704-3.866-1.35-.13-.331-.69-1.352-1.18-1.625-.402-.216-.977-.748-.014-.762.906-.014 1.553.834 1.769 1.179 1.035 1.74 2.688 1.25 3.349.948.1-.747.402-1.25.733-1.538-2.559-.287-5.232-1.279-5.232-5.678 0-1.25.445-2.285 1.178-3.09-.115-.288-.517-1.467.115-3.048 0 0 .963-.302 3.163 1.179.92-.259 1.897-.388 2.875-.388.977 0 1.955.13 2.875.388 2.2-1.495 3.162-1.179 3.162-1.179.633 1.581.23 2.76.115 3.048.733.805 1.179 1.825 1.179 3.09 0 4.413-2.688 5.39-5.247 5.678.417.36.776 1.05.776 2.128 0 1.538-.014 2.774-.014 3.162 0 .302.216.662.79.547C20.709 21.637 24 17.324 24 12.25 24 5.896 18.854.75 12.5.75Z"></path>
          </svg>
        </a>
        {user && user.phone ? (
          <span className="userName-pho">
            {user && user.phone ? (
              <span className="userName-pho">
                <Avatar size="large" src={`/file/${user.profilePictureUrl}`} />
                <Link to="/personal">{user.phone}</Link>
                <div className="dropdown-menu">
                  <div className="menu-item" onClick={handleLogout}>
                    退出登录
                  </div>
                </div>
              </span>
            ) : (
              <LoginRegisterButtons />
            )}
          </span>
        ) : (
          <LoginRegisterButtons />
        )}
      </div>
    </header>
  );
};

export default Header;
